import moment from 'moment'
import Vue from 'vue'

Vue.filter('date', value => {
    if (!value) {
        return ''
    }

    if (typeof value.date !== "undefined") {
        return moment(value.date).format('DD.MM.YYYY')
    }

    return moment(value).format('DD.MM.YYYY')
})

Vue.filter('datetime', value => {
    if (!value) {
        return ''
    }

    if (typeof value.date !== "undefined") {
        return moment(value.date).format('DD.MM.YYYY HH:mm')
    }

    return moment(value).format('DD.MM.YYYY HH:mm')
})

Vue.filter('time', value => {
    if (!value) {
        return ''
    }

    if (typeof value.date !== "undefined") {
        return moment(value.date).format('HH:mm')
    }

    return moment(value).format('HH:mm')
})

Vue.filter('week', value => {
    if (!value) {
        return ''
    }

    if (typeof value.date !== "undefined") {
        return moment(value.date).format('W')
    }

    return moment(value).format('W')
})

Vue.filter('month', value => {
    if (!value) {
        return ''
    }

    if (typeof value.date !== "undefined") {
        return moment(value.date).format('MM.YYYY')
    }

    return moment(value).format('MM.YYYY')
})

Vue.filter('number', value => Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'))

Vue.filter('price', value => Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr.')

Vue.filter('ucfirst', value => value.charAt(0).toUpperCase() + value.slice(1))
